package link.erpango.quip.platform

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.launch
import link.erpango.quip.core.SharedFactory
import link.erpango.quip.utils.DatetimeUtils

private const val ONE_DAY_MS = 24 * 60 * 60 * 1000
private const val LAST_REFRESH_KEY = "quip_last_token_refresh"

object TokenRefreshScheduler {

    fun start(factory: SharedFactory) {
        console.log("TokenRefreshScheduler [JS]: iniciando. Intervalo de refresco: 24h")

        // Refresco periódico cada 24h
        window.setInterval({
            console.log("TokenRefreshScheduler [JS]: intervalo de 24h alcanzado, ejecutando refresco de token")
            GlobalScope.launch {
                factory.tokenRefreshManager.tryRefreshToken()
                saveLastRefreshTime()
                val nextMs = DatetimeUtils.currentTimeMillis() + ONE_DAY_MS
                console.log("TokenRefreshScheduler [JS]: refresco ejecutado. Próxima ejecución por intervalo aprox: ${DatetimeUtils.formatDateTime(nextMs)}")
            }
        }, ONE_DAY_MS)

        // Al volver a la pestaña, refrescar si han pasado más de 23h
        document.addEventListener("visibilitychange", {
            if (document.asDynamic().visibilityState == "visible") {
                val last = window.localStorage.getItem(LAST_REFRESH_KEY)?.toLongOrNull() ?: 0L
                val elapsed = DatetimeUtils.currentTimeMillis() - last
                val elapsedHours = elapsed / (60 * 60 * 1000)
                if (elapsed > 23 * 60 * 60 * 1000L) {
                    console.log("TokenRefreshScheduler [JS]: pestaña recuperada tras ${elapsedHours}h inactiva — ejecutando refresco adelantado")
                    GlobalScope.launch {
                        factory.tokenRefreshManager.tryRefreshToken()
                        saveLastRefreshTime()
                    }
                } else {
                    console.log("TokenRefreshScheduler [JS]: pestaña recuperada (${elapsedHours}h transcurridas) — no es necesario refrescar aún")
                }
            }
        })
    }

    private fun saveLastRefreshTime() {
        window.localStorage.setItem(LAST_REFRESH_KEY, DatetimeUtils.currentTimeMillis().toString())
    }
}
